import * as React from 'react';

export const OverlayCardContainer: React.FC<React.ComponentProps<'div'>> = (
  props,
) => {
  return (
    <div
      {...props}
      className="-mx-6 px-6 -mt-6 sm:pt-6 bg-split-x-1/3 from-primary-500 to-transparent sm:bg-none sm:bg-transparent"
    />
  );
};
